import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconModule } from '../icon/icon.module';
import { PhxAlertComponent } from './phx-alert.component';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';

@NgModule({
  declarations: [
    PhxAlertComponent,
  ],
  imports: [
    CommonModule,
    PhxIconModule,
    PhxIconButtonModule,
  ],
  exports: [
    PhxAlertComponent,
  ]
})
export class PhxAlertModule { }
